<template>
  <!-- 封装的侧边 新闻动态-->
  <div class="Rankingpage">
    <div class="Theheader-two">
      <h4>{{ mkpublic !== undefined ? mkpublic : "任务发布" }}</h4>
      <div class="inform-two">
        <ul>
          <li
            class="Popularity"
            v-for="(item, index) in types"
            :key="index"
            @click="Jump(item)"
          >
            <div class="wew">{{ index + 1 }}</div>
            <p class="psha" align="left">{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// import { nextTick } from 'vue/types/umd'
// import { selpublictj } from '../../api/patient'
export default {
  props: ["dat"],
  data() {
    return {
      tdata: "",
      vales: "",
      mkpublic: "",
      templ: "",
      types: "",
    };
  },
  created() {
    // this.selpublica()
    // console.log(this.dat, '123')
  },
  methods: {
    Jump(item) {
      this.$emit("parameters", item);
      window.scrollTo({
        top: 0,
      });
    },
    // selpublica () {
    //   var data = new FormData()
    //   data.append('mkpublic', this.types)
    //   selpublictj(data).then(res => {
    //     console.log(res)
    //     this.templ = res
    //   })
    // }
  },
  watch: {
    dat(newVal, oldVal) {
      this.types = newVal;

      // this.dat()
      this.mkpublic = this.types[0].mkpublic;
    },
  },
};
</script>
<style scoped lang="scss">
.Theheader-two {
  width: 289px;
  margin-top: 40px;
  margin-left: 20px;
  padding-bottom: 15px;
  // background: red;
  h4 {
    display: flex;
    // width: 90px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-bottom: 30px;
  }
  .inform-two {
    padding-left: 22px;
    ul {
      .Popularity {
        display: flex;
        margin-bottom: 16px;
        cursor: pointer;
        img {
          width: 19px;
          height: 16px;
          margin-right: 8px;
        }
        div {
          width: 19px;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          /* line-height: px; */
          margin-right: 8px;
        }
        p {
          width: 210px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 1; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }
      }
      li:hover {
        // background: #4CCAFF;
        div {
          color: #4ccaff;
        }
        p {
          color: #4ccaff;
        }
      }
    }
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Theheader-two {
    width: 80vw;
    margin-top: 40px;
    margin-left: 20px;
    padding-bottom: 15px;
    // background: red;
    h4 {
      display: flex;
      // width: 90px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      margin-bottom: 30px;
    }
    .inform-two {
      padding-left: 22px;
      ul {
        .Popularity {
          display: flex;
          margin-bottom: 16px;
          cursor: pointer;
          img {
            width: 19px;
            height: 16px;
            margin-right: 8px;
          }
          p {
            width: 80vw;
          }
        }
      }
    }
  }
}
</style>
